'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTransform = function MdTransform(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.6 13.4v-3.4h10c1.8 0 3.4 1.6 3.4 3.4v10h-3.4v-10h-10z m20 16.6h-6.6v3.4h3.4l-5 5-5-5h3.2v-3.4h-13.2c-1.8 0-3.4-1.6-3.4-3.4v-13.2h-6.6v-3.4h6.6v-3.4h-3.4l5-5 5 5h-3.2v20h23.2v3.4z' })
        )
    );
};

exports.default = MdTransform;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/transform.js
// module id = 1560
// module chunks = 36573943044255 79611799117203 213534597649335